import request from '@api/request';

export const commentApi = async (params) =>
  await request({
    url: '/comments/create',
    type: 'post',
    params,
  });
